import React, { createContext, ReactNode, useContext } from 'react';
import DataStore from '../../core/stores/DataStore';
import AppStore from '../stores/AppStore';

interface DataStoreProviderProps {
  children: ReactNode;
  dataStore: any;
  appStore: any;
}

const StoresContext = createContext({
  dataStore: new DataStore(),
  appStore: new AppStore(),
});

/* Hook to use stores in any functional component */
export const useDataStore = () => useContext(StoresContext).dataStore;
export const useAppStore = () => useContext(StoresContext).appStore;

const StoresProvider = ({ children, dataStore, appStore }: DataStoreProviderProps) => {
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const stores = {
    dataStore,
    appStore,
  };

  return <StoresContext.Provider value={stores}>{children}</StoresContext.Provider>;
};

export default StoresProvider;
